import React, { Fragment } from 'react';

import { isEmbeddedConfluence_DO_NOT_USE } from '@atlassian/embedded-confluence/isEmbeddedConfluence';
import { Box } from '@atlaskit/primitives';

import { getCompanyHubRoute } from '@confluence/ssr-app/entry-points/routes';
import { fg } from '@confluence/feature-gating';
import { HubRendererLoader } from '@confluence/company-hub';
import { ClassicEditorContextProviderLoader } from '@confluence-classic/confluence-fabric-editor/src/components/ClassicEditorContextProvider';
import { usePageContentId } from '@confluence/page-context';
import { EmbeddedViewPageLoader } from '@confluence/embedded-confluence';

import { SpaceOverviewRouteComponent } from './SpaceOverviewRouteComponent';
import { ContentExtensionsProvider } from '../../ContentExtensionsProvider';
import { LazyDwellTime } from '../lazyComponents';
import { CommentContextWrapper } from '../commentContextWrapper';
import { CommentsSectionLoader } from '@confluence-classic/confluence-utils/entry-points/CommentsSectionLoader';

type EmbeddedHubRendererProps = {
	spaceKey: string;
	contentId: string;
};

const EmbeddedHubRenderer = ({ spaceKey, contentId }: EmbeddedHubRendererProps) => {
	return (
		<Box padding="space.200">
			<EmbeddedViewPageLoader
				contentId={contentId}
				spaceKey={spaceKey}
				classicComments={CommentsSectionLoader}
				ClassicEditorContextProviderLoader={ClassicEditorContextProviderLoader}
				showHeaderButtons={false}
			/>
		</Box>
	);
};

type CompanyHubRouteComponentProps = {
	spaceKey: string;
};

export const CompanyHubRouteComponent = ({ spaceKey }: CompanyHubRouteComponentProps) => {
	const [contextContentId] = usePageContentId();
	const contentId: string = contextContentId ?? '';
	const component = isEmbeddedConfluence_DO_NOT_USE() ? (
		<EmbeddedHubRenderer contentId={contentId} spaceKey={spaceKey} />
	) : (
		<HubRendererLoader spaceKey={spaceKey} />
	);

	if (!fg('company_hub_hub-renderer')) {
		return <SpaceOverviewRouteComponent spaceKey={spaceKey} />;
	}

	return (
		<Fragment>
			<ContentExtensionsProvider>
				<CommentContextWrapper>{component}</CommentContextWrapper>
			</ContentExtensionsProvider>
			<LazyDwellTime />
		</Fragment>
	);
};

export const CompanyHubRoute = getCompanyHubRoute(SpaceOverviewRouteComponent);
